<template>
  <page-outline :title="'Information du document'">
    <template slot="pageContent">
      <spinner v-if="activateSpinner"></spinner>
      <div v-else>
        <!-- Details List -->
        <b-row>
          <b-col sm="6" class="form-group">
            <form-read-group-label-input
              :idLabel="$t('suppliers.supplier')"
              :inputValue="document.GroupReference">
            </form-read-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group">
            <form-read-group-label-input
              :idLabel="$t('common.status.status_label')"
              :inputValue="getStatusLabel(document.Status, document.Role)"
              :statusIcon="getStatusIcon(document.Status, '0')">
            </form-read-group-label-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6" class="form-group">
            <form-read-group-label-input
              :idLabel="$t('businessDocuments.document_type')"
              :inputValue="document.Type">
            </form-read-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group">
            <form-read-group-label-input
              :idLabel="$t('common.date_label')"
              :inputValue="getDate(document.LastUpdateDate)">
            </form-read-group-label-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="form-group">
            <a @click="seeSupplierDetails(document.IdSeller)"
              href="#" class="linkAction">
              Voir le dossier KYB
            </a>
          </b-col>
        </b-row>
        <form-accordion :title="$t('businessDocuments.doc_details')"
          v-if="document.Serialize !== null && Object.keys(document.Serialize).length !== 0 && this.serializeGet.length !== 0">
          <b-row>
            <template v-for="value in serializeGet">
              <template v-if="value.type === 'object'">
                <b-col sm="6" class="form-group"
                  v-for="(subvalue, subindex) in value[0]" :key="subindex">
                  <form-read-group-label-input
                    :idLabel="$t('businessDocuments.serialize.' + document.Type + '.' + subindex.name)"
                    :inputValue="document.Serialize[value.name].Value[0][subindex.name]"
                    :specificErrorIndicator="document.Serialize[value.name].Valid === '0'"
                    :warningIndicator="showWarningIndicator(value.name, document.Serialize)"
                    :specificMessage="getAssociatedMessage(document.Serialize[value.name].Description)">
                  </form-read-group-label-input>
                </b-col>
              </template>
              <b-col sm="6" class="form-group" v-else-if="value.type === 'date'">
                <form-read-group-label-input
                  :idLabel="$t('businessDocuments.serialize.' + document.Type + '.' + value.name)"
                  :inputValue="document.Serialize[value.name].Value"
                  :specificErrorIndicator="document.Serialize[value.name].Valid === '0'"
                  :warningIndicator="showWarningIndicator(value.name, document.Serialize)"
                  :specificMessage="getAssociatedMessage(document.Serialize[value.name].Description)">
                </form-read-group-label-input>
              </b-col>

              <b-col sm="6" class="form-group" v-else-if="value.type === 'boolean' && value.change === '0'">
                <label>{{ $t('businessDocuments.serialize.' + document.Type + '.' + value.name) }}</label>

                <div v-if="document.Serialize[value.name].Value === '0'">
                  <i class="icon fa fa-check" style="color:green;font-size:30px;"></i>
                  &nbsp;&nbsp;{{ $t('common.status.valid_control_key') }}
                </div>
                <div v-else>
                  <i class="icon fa fa-ban" style="color:red;font-size:30px;"></i>&nbsp;&nbsp;
                  <span v-if="document.Serialize[value.name].Value === '1'">
                    {{ $t('errors.invalid_control_key') }}
                  </span>
                  <span v-else-if="document.Serialize[value.name].Value === '2'">
                    {{ $t('errors.out_of_date') }}
                  </span>
                  <span v-else-if="document.Serialize[value.name].Value === '3'">
                    {{ $t('errors.invalid_control_key_out_of_date') }}
                  </span>
                </div>
              </b-col>
              <b-col sm="6" class="form-group" v-else-if="value.type === 'list'">
                <form-write-group-label-input inputType="listeSelect"
                  :idLabel="$t('businessDocuments.serialize.' + document.Type + '.' + value.name)"
                  :specificErrorIndicator="document.Serialize[value.name].Valid === '0'"
                  :warningIndicator="showWarningIndicator(value.name, document.Serialize)"
                  :specificMessage="getAssociatedMessage(document.Serialize[value.name].Description)"
                  :additionalMessage="document.Serialize[value.name].ValueOCR ? 'OCR : ' + getOCRValueLabel(value.name, document.Serialize[value.name].ValueOCR) : ''">
                  <select v-model="document.Serialize[value.name].Value" class="form-control" readonly>
                    <option value="">{{ $t('ocr.slct_' + value.name) }}</option>
                    <option v-for="listValue in getOCRValues(value.name)" :key="listValue"
                      v-if="getOCRValueLabel(value.name, listValue)"
                      :value="listValue">
                      {{ getOCRValueLabel(value.name, listValue) }}
                    </option>
                  </select>
                </form-write-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group" v-else>
                <form-write-group-label-input v-model="document.Serialize[value.name].Value"
                  :idLabel="$t('businessDocuments.serialize.' + document.Type + '.' + value.name)"
                  :specificErrorIndicator="document.Serialize[value.name].Valid === '0'"
                  :warningIndicator="showWarningIndicator(value.name, document.Serialize)"
                  :specificMessage="getAssociatedMessage(document.Serialize[value.name].Description)">
                  <template slot="additionalMessage">
                    <div v-html="getAdditionalMessage(document.Serialize[value.name])"></div>
                  </template>
                </form-write-group-label-input>
              </b-col>
            </template>
          </b-row>
          <b-row class="justify-content-start">
            <b-col md="3" class="form-group">
              <f7-button class="button-action milkyBlockBlack"
                @click="controlFields()">
                {{ 'Vérifier' }}
              </f7-button>
            </b-col>
            <b-col md="3" class="form-group">
              <f7-button class="button-action milkyBlockBlack"
                @click="cancel()">
                {{ 'Annuler' }}
              </f7-button>
            </b-col>
          </b-row>
        </form-accordion>
        <b-row>
          <b-col class="form-group">
            <a href="#" class="linkAction" @click="showDocument = !showDocument">
              Cliquer ici pour afficher/cacher le document
            </a>
          </b-col>
        </b-row>
        <b-row v-if="showDocument">
          <b-col class="form-group">
            <document-viewer :src="document.Data">
            </document-viewer>
          </b-col>
        </b-row>
        <b-row class="justify-content-start">
          <b-col md="3" class="form-group">
            <f7-button class="button-action milkyBlockBlack"
              @click="downloadDocument(document.Name, document.Data)">
              <i class="icon fa fa-download"></i>
              {{ $t('common.dwnld') }}
            </f7-button>
          </b-col>
          <b-col md="3" class="form-group">
            <f7-button class="button-action milkyBlockBlack"
              @click="uploadDocument()">
              <i class="icon fa fa-upload"></i>
              {{ $t('common.updt') }}
            </f7-button>
          </b-col>
          <b-col md="3" class="form-group">
            <f7-button class="button-action milkyBlockBlack"
              @click="updateDecisionLevel2($event, document, 'ACCP')">
              <i class="icon list-icon icon-accept-doc"></i>
              {{ $t('common.accpt') }}
            </f7-button>
          </b-col>
          <b-col md="3" class="form-group">
            <f7-button class="button-action milkyBlockBlack"
              @click="updateDecisionLevel2($event, document, 'RFSL')">
              <i class="icon list-icon icon-reject-doc"></i>
              {{ $t('common.refus') }}
            </f7-button>
          </b-col>
        </b-row>
        <form-accordion :title="$t('businessDocuments.request_history')"
          v-if="document.History != null">
          <b-row>
            <b-col class="form-group">
              <table class="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th>{{ $t('businessDocuments.action_date') }}</th>
                    <th>{{ $t('businessDocuments.doc_status_label') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="transactionDetailFontSize" v-for="(value, index) in document.History">
                    <td class="dateTimehistoryHeight">
                      {{ getDateTime(value.DateChange) }}
                    </td>
                    <td>
                      <b-row>
                        <b-col sm="7" class="statusHistoryLabel">
                          {{ getStatusLabel(value.Status) }}
                          <i :class="'icon icon-transaction-detail ' + getStatusIcon(value.Status)"></i>
                        </b-col>
                        <b-col sm="5">
                          <f7-button class="xmlButtonBackground"
                            @click="downloadDocument(value.DocumentName, value.DocumentData)"
                            v-if="showDocumentHistoric(value)">
                            {{ $t('common.dwnld') }}
                          </f7-button>
                        </b-col>
                      </b-row>
                      <div class="item-content"
                        v-if="value.Status === 14 && value.DecisionMessage !== ''">
                        <div class="item-inner" style="display:block;">
                          <div class="item-title-row" style="font-style:italic;">
                            {{ $t('common.rfs_cmmnt') }}:
                          </div>
                          <div class="item-title-row">
                            <div style="color:#8e8e93">
                              {{ value.DecisionMessage }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-col>
          </b-row>
        </form-accordion>
      </div>
    </template>
  </page-outline>
</template>

<script>
import DocumentViewer from '@/components/common/DocumentViewer'
import FormAccordion from '@/components/common/FormAccordion.vue'
import FormReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import FormWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import Spinner from '@/components/common/spinner.vue'

import rfslCodes from '@/pages/requests/detailPages/businessDocumentDetailPages/data/rsflCodes.json'

import documentSerialize from '@/helpers/documentSerialize.json'
import ocrValues from '@/data/ocrValues.json'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import {ibanWithSpaces, statusIcon, statusLabel} from '@/helpers/labels'

export default {
  name: 'DocumentToValidateDetailPage',
  props: ['direction'],
  components: {
    'document-viewer': DocumentViewer,
    'form-accordion': FormAccordion,
    'form-read-group-label-input': FormReadGroupLabelInput,
    'form-write-group-label-input': FormWriteGroupLabelInput,
    'page-outline': PageOutline,
    'spinner': Spinner
  },
  data () {
    return {
      activateSpinner: true,
      apiControlsDocuments: ['CERT_VIGI', 'KBIS'],
      controlsDone: false,
      document: {},
      canAccept: false,
      canRefuse: false,
      serializeGet: {},
      serializeInit: {},
      showDocument: false
    }
  },
  created () {
    this.document = this.$engine.services.businessDocuments.currentDocument
    this.getDocumentDetails()
    // this.canAccept = this.$engine.rights.rightIs('dp_response_accepter', true)
    // this.canRefuse = this.$engine.rights.rightIs('dp_response_refuser', true)
  },
  methods: {
    cancel () {
      this.document.Serialize = Object.assign({}, this.serializeInit)
    },
    controlFields () {
      this.controlsDone = false
      this.$f7.showPreloader(this.$i18n.t('sent.ocr_loading', {request_type: this.$i18n.t('servicesNames.business_doc_sing')}))
      let documentInformations = {}
      let attributes = Object.keys(this.document.Serialize)
      for (var j = 0; j < attributes.length; j++) {
        if (typeof this.document.Serialize[attributes[j]] === 'object') {
          if (this.document.Serialize[attributes[j]].Value) {
            documentInformations[attributes[j]] = this.document.Serialize[attributes[j]].Value
          }
        } else {
          if (this.document.Serialize[attributes[j]]) {
            documentInformations[attributes[j]] = this.document.Serialize[attributes[j]]
          }
        }
      }
      this.$engine.services.suppliers.uploadDocument({
        DocumentType: this.document.Type,
        DocumentName: this.document.Name,
        ocr: '2',
        ControlsMode: '3',
        DocumentData: this.document.Data,
        Serialize: documentInformations
      }).then(response => {
        this.$f7.hidePreloader()
        this.$f7.modal({
          title: this.$i18n.t('sent.ocr_end'),
          text: '<span class="preloader"></span>'
        })
        this.$f7.hidePreloader()
        this.$f7.closeModal()
        response = response.data.ControlsInformations
        let attributes = Object.keys(response)
        for (var i = 0; i < attributes.length; i++) {
          this.document.Serialize[attributes[i]] = response[attributes[i]]
        }
        this.controlsDone = true
      })
      .catch(err => {
        for (var i = 0; i < this.serializeGet.length; i++) {
          this.document.Serialize[this.serializeGet[i].name] = {
            Value: '',
            Valid: '0',
            Description: 'Data not found'
          }
        }
        this.ocrDone = true
        this.$f7.hidePreloader()
        this.$f7.closeModal()
        this.$f7.alert(this.$i18n.t('errors.too_important_tilt') + ' ' + err)
        console.log(this.$i18n.t('errors.too_important_tilt') + ' ' + err)
      })
    },
    downloadDocument (name, data) {
      const linkSource = data
      const downloadLink = document.createElement('a')
      downloadLink.href = linkSource
      downloadLink.download = name
      downloadLink.click()
    },
    formatValue (name, value) {
      let valueFormatted = value
      switch (name) {
        case 'Iban':
          valueFormatted = ibanWithSpaces(value)
          break
        default:
          break
      }
      return valueFormatted
    },
    getAdditionalMessage (result) {
      let message = ''
      if (this.controlsDone) {
        if (this.apiControlsDocuments.includes(this.document.Type)) {
          if (result.ValueAPI) {
            message += 'API : ' + result.ValueAPI
          } else {
            message += this.$i18n.t('errors.Data_not_found_from_API')
          }
          message += '<br/>'
        }
        if (result.ValueOCR) {
          message += 'OCR : ' + result.ValueOCR
        } else {
          message += this.$i18n.t('errors.Data_not_found_from_OCR')
        }
      }
      return message
    },
    getAssociatedMessage (errorMessage) {
      if (errorMessage == null) {
        return ''
      }
      if (errorMessage === 'Firstname and lastname are not consistency' || errorMessage === 'Name is not consistency') {
        return this.$i18n.t('errors.OCR_not_known_names_firstnames')
      }
      if (errorMessage === 'Name is close') {
        return this.$i18n.t('errors.OCR_almost_known_names_firstnames')
      }
      let parsedError = errorMessage.replace(/\s/g, '_')
      if (this.$i18n.t('errors.' + parsedError) !== 'errors.' + parsedError) {
        return this.$i18n.t('errors.' + parsedError)
      }
      return this.$i18n.t('errors.Data_format_invalid')
    },
    getDate (date) {
      return this.$options.filters.formatDate(date)
    },
    getDateTime (date) {
      return this.$options.filters.formatDateTime(date)
    },
    getDocumentDetails () {
      let that = this
      this.$engine.services.businessDocuments.getDocumentDetails(
        this.document.IdDocument
      )
      .then(resp => {
        that.document = resp.data.Documents[0]
        that.serializeGet = documentSerialize[that.document.Type].fields

        if (
          that.document.Serialize !== null &&
          Object.keys(that.document.Serialize).length !== 0 &&
          that.serializeGet.length !== 0
        ) {
          for (let key in that.serializeGet) {
            let value = that.serializeGet[key]
            that.document.Serialize[value.name] = {
              Valid: '1',
              Value: that.formatValue(value.name, that.document.Serialize[value.name])
            }
          }
        }
        that.serializeInit = Object.assign({}, that.document.Serialize)

        that.activateSpinner = false
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that, that.$i18n)
      })
    },
    getOCRValueLabel (field, value) {
      return this.$i18n.t('ocr.' + field + '.' + value.replace(/\s/g, '_'))
    },
    getOCRValues (field) {
      return ocrValues[field]
    },
    getStatusIcon (status, negotStatus) {
      return statusIcon('Doc_' + status, negotStatus)
    },
    getStatusLabel (status, role) {
      return statusLabel(this.$i18n, 'Doc_' + status, role, -1, -1, this.$engine.user.get())
    },
    goBack () {
      loadPage(this, {url: '/inbox/2/2'})
    },
    seeSupplierDetails (seller) {
      this.$engine.services.suppliers.selectedSupplier.IdSeller = seller
      loadPage(this, { url: '/suppliers/details/' })
    },
    showDocumentHistoric (documentHistoric) {
      return documentHistoric.Status === 11 && documentHistoric.DocumentData !== ''
    },
    sendDecisionUpdateLevel2 (document, action, decisionMessage = '') {
      let that = this
      let paramsToSend = {
        Receiver: this.$engine.user.get().identifier,
        AttachmentId: document.DocumentIdentifier,
        AttachmentName: document.Name,
        TransactionStatus: action,
        DecisionMessage: decisionMessage,
        IdDocument: document.IdDocument
      }
      this.$engine.services.businessDocuments.updateDocument(paramsToSend)
      .then(response => {
        that.status = response.status
        if (response.status === 200) {
          that.$f7.hidePreloader()
          that.$f7.modal({
            title: this.$i18n.t('businessDocuments.updated_doc'),
            text: '<span class="preloader"></span>'
          })
          if (action === 'ACCP') {
            this.document.Status = '16'
          } else if (action === 'RFSL') {
            this.document.Status = '14'
          }
          setTimeout(function () {
            that.$f7.closeModal()
          }, 2000)
        }
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    showWarningIndicator (valueName, serializedDoc) {
      if (valueName === 'Name') {
        return parseInt(serializedDoc[valueName].Score) >= 201 && parseInt(serializedDoc[valueName].Score) <= 399
      }
      return false
    },
    updateDecisionLevel2 (e, document, action) {
      e.stopPropagation()
      let that = this
      let options = ''
      let type = document.Type
      let rfslCodesType = rfslCodes[type]
      let modalText = ''

      for (let id in rfslCodesType) {
        let label = that.$i18n.t('common.rfsl.' + type + '.s_' + rfslCodesType[id])
        let value = that.$i18n.t('common.rfsl.' + type + '.l_' + rfslCodesType[id])
        options += '<option value="' + value + '">' + label + '</option>'
      }

      if (action === 'RFSL') {
        modalText = '<div>' +
                      '<span>Sélectionner un motif de refus :</span>' +
                      '<select id="selectCodeRefus" style="width:200px;">' +
                        options +
                      '</select>' +
                    '</div>'
      }

      this.$f7.modal({
        title: action === 'RFSL' ? that.$i18n.t('businessDocuments.refuse_doc_confirmation') : that.$i18n.t('businessDocuments.accept_doc_confirmation'),
        text: modalText,
        buttons: [
          {
            text: that.$i18n.t('common.cncl'),
            onClick: function () {}
          },
          {
            text: action === 'RFSL' ? that.$i18n.t('common.refus') : that.$i18n.t('common.accpt'),
            onClick: function () {
              that.sendDecisionUpdateLevel2(document, action, that.Dom7('#selectCodeRefus').val())
            }
          }
        ]
      })
    },
    uploadDocument () {
      let that = this
      this.activateSpinner = true
      this.$engine.services.suppliers.uploadDocument({
        IdDocument: this.document.IdDocument,
        DocumentType: this.document.Type,
        DocumentName: this.document.Name,
        ocr: '1',
        DocumentData: this.document.Data,
        Serialize: this.document.Serialize,
        IdSeller: this.document.IdSeller
      })
      .then(resp => {
        that.activateSpinner = false
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that, that.$i18n)
        console.log(error)
      })
    }
  }
}
</script>
<style scoped>
.linkAction {
  color: dodgerblue;
}
</style>



// WEBPACK FOOTER //
// DocumentToValidateDetailPage.vue?78c01148